import { render, staticRenderFns } from "./challengingordermanagement.vue?vue&type=template&id=e68df044&scoped=true&"
import script from "./challengingordermanagement.vue?vue&type=script&lang=js&"
export * from "./challengingordermanagement.vue?vue&type=script&lang=js&"
import style0 from "./challengingordermanagement.vue?vue&type=style&index=0&id=e68df044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68df044",
  null
  
)

export default component.exports